export function ConnectedIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.910004 13.91C4.70178 9.52982 10.2066 7.00906 16 7C21.7934 7.00906 27.2982 9.52982 31.09 13.91L29.67 15.33C26.2633 11.3162 21.2647 9.00241 16 9.00241C10.7354 9.00241 5.73673 11.3162 2.33 15.33L0.910004 13.91Z"
        fill="white"
      />
      <path
        d="M16 14C12.0517 14.0048 8.30305 15.7367 5.74 18.74L7.16 20.16C9.33899 17.5244 12.5803 15.9986 16 15.9986C19.4197 15.9986 22.661 17.5244 24.84 20.16L26.26 18.74C23.697 15.7367 19.9483 14.0048 16 14Z"
        fill="white"
      />
      <path
        d="M16 21C13.8976 21.0024 11.9075 21.9497 10.58 23.58L12 25C12.9443 23.741 14.4262 23 16 23C17.5738 23 19.0557 23.741 20 25L21.43 23.57C20.0983 21.9407 18.1043 20.997 16 21Z"
        fill="white"
      />
    </svg>
  );
}

export function DisconnectedIcon(props: { className?: string }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M25.47 9.33L30 4.81V2L2 30H4.82L11 23.85L12.1 25C13.0292 23.7179 14.5166 22.9589 16.1 22.9589C17.6834 22.9589 19.1708 23.7179 20.1 25L21.54 23.56C19.5311 21.0831 16.1019 20.2772 13.2 21.6L18.56 16.25C21.0563 16.7976 23.2982 18.1631 24.93 20.13L26.34 18.72C24.7091 16.8079 22.5751 15.3911 20.18 14.63L24 10.82C26.2083 11.9049 28.1717 13.4294 29.77 15.3L31.19 13.88C29.571 12.0333 27.6336 10.4921 25.47 9.33Z"
        fill="white"
      />
      <path
        d="M7.06 19.94L12.53 14.47C9.92213 15.1853 7.58844 16.6656 5.83 18.72L7.06 19.94Z"
        fill="white"
      />
      <path
        d="M17.93 9.1C17.32 9 16.71 9 16.09 9C10.8284 8.99965 5.83005 11.3015 2.41 15.3L1 13.88C4.79734 9.51097 10.3014 7.00151 16.09 7C17.298 7.00124 18.5032 7.11507 19.69 7.34L17.93 9.1Z"
        fill="white"
      />
    </svg>
  );
}
